import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Form, Control, actions, Errors } from 'react-redux-form';
import PageTitle from '../../common/page-title';
import LockPopup from '../lock-popup';
import { verifyPIN, requestPIN } from '../../../actions/login';
import {Grid, Row, Col, Button, FormGroup} from 'react-bootstrap';
import TextViewer from '../../common/editor/text-viewer';
import qs from 'qs';

import './style.css';

class PINForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showNewPin: false,
      showLockPopup: false,
      pinExpired: false
    };
  }

  componentWillMount() {
    const {dispatch} = this.props;
    dispatch(actions.reset('deep.resetPW.step2'));
  }

  handleSubmit = (payLoad) => {
    let state = null;
    if(this.props.location.search) {
        const params = qs.parse(this.props.location.search.slice(1));
        if (params.state) {
            state = params.state;
        }
    }
    const pLoad = {...payLoad, state: state};

    const {dispatch} = this.props;
    dispatch(actions.submitFields('deep.resetPW.step2', verifyPIN(pLoad)
      .catch((error) => {

        dispatch({type: 'VERIFY_PIN_REJECTED', payLoad: error.response.data});
        dispatch(actions.load('deep.resetPW.step2.pin', ''));

        const errors = error.response.data.errors;
        let rejectErrors = [];
        if (Object.prototype.toString.call(errors) === '[object Array]') {
          errors.forEach((curr) => {
            if (curr === 'PIN_EXPIRED') {
              rejectErrors.push({pin_expired: true})
              this.setState({pinExpired: true});
            }
            if (curr === 'INVALID_CREDENTIALS') {
              rejectErrors.push({invalid_creds: true})
            }
            if (curr === 'INVALID_PIN') {
              rejectErrors.push({invalid_pin: true});
              this.setState({showNewPin: true});
            }
            if (curr === 'INVALID_STATE') {
              rejectErrors.push({invalid_state: true})
            }
            if (curr === 'ACCOUNT_LOCKED') {
              rejectErrors.push({locked: true});
              this.setState({showLockPopup: true});
            }
          });
          return Promise.reject(rejectErrors);
        } else {
          return Promise.reject(errors.user);
        }

      })
    ));
  };

  requestNeWPIN = () => {
    const { dispatch } = this.props;
    dispatch(actions.submit('deep.resetPW.step1', requestPIN(null)
      .catch((error) => {
        dispatch({type: 'PW_RESET_VALUE_REJECTED', payLoad: error.response.data});

        const errors = error.response.data.errors;
        if (Object.prototype.toString.call(errors) === '[object Array]') {
          errors.forEach((curr) => {
            if (curr === 'ACCOUNT_LOCKED') {
              this.setState({showLockPopup: true});
            }
          });
        }

      })
    ));
  };

  resetErrors = () => {
    this.props.dispatch(actions.resetErrors('deep.resetPW.step2'));
  };

  render() {

    return (
      <Grid fluid className="pin-form-wrapper">
          <Row>
            <Col lg={12}>
              <PageTitle>Please enter your pin</PageTitle>
              <TextViewer pageSlug='enter-pin'></TextViewer>
            </Col>
          </Row>

          { !this.state.showNewPin &&
          <Row>
            <Col lg={6}>
              <Form model="deep.resetPW.step2"
                    className="pin-form"
                    onChange={(values) => this.resetErrors()}
                    onSubmit={(values) => this.handleSubmit(values)}>

                <FormGroup>
                  <label htmlFor=".pin">Please enter your PIN</label>
                  <Control.text className="pin-field form-control" model=".pin" type="text"/>

                  <Errors show={{
                            touched: true
                          }}
                          className="errors"
                          model=".pin"/>
                </FormGroup>

                <FormGroup>
                  <Errors className="errors"
                          model="deep.resetPW.step2"
                          messages={{
                            pin_expired: 'PIN expired',
                            invalid_creds: 'Invalid Credentials',
                            invalid_pin: 'Invalid PIN given',
                            invalid_state: 'Invalid State',
                            pin_exceeded: 'PIN attempts exceeded'
                          }}/>

                  <Button type="submit"
                          disabled={!this.props.formValid}
                          className="red-btn pull-right submit">
                    Submit
                  </Button>
                </FormGroup>


              </Form>
            </Col>
          </Row>
          }
          {this.state.showNewPin &&
          <Row>
            <Col lg={6}>
              {this.state.pinExpired ? "PIN code expired" : "Your PIN number could not be verified, please request a new PIN"}
              <br />
              <Button
                className="red-btn"
                bsSize="large"
                onClick={() => {
                  this.setState({
                    showNewPin: false,
                    pinExpired: false
                  });
                  this.requestNeWPIN();
                }}>REQUEST NEW PIN</Button>
            </Col>
          </Row>
          }
          { this.state.showLockPopup && <LockPopup route="/login"/> }
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    formValid: state.deep.forms.resetPW.step2.$form.valid
  };
};

export default connect(mapStateToProps)(PINForm);



// WEBPACK FOOTER //
// ./src/components/auth/forgotten-password-2/index.jsx